export default __webpack_public_path__ + "static/media/menu.05015f29.png";